export const getEntityQuestions = state => state.entityInfo.entityOverview.questions;
export const getEmployeeInterviewsList = state => state.entityInfo.employeeInterviews.list;
export const getSelectedEmployeeInterview = state => state.entityInfo.employeeInterviews.selected;
export const getSelectedEntityDetail = state => state.entityInfo.entityDetails.selected;
export const getEntityDetails = state => state.entityInfo.entityDetails.list;
export const getEntityDetailTypes = state => state.entityInfo.entityDetails.listDetailTypes;
export const getOverviewQuestionsLoadingState = state => state.entityInfo.entityOverview.overviewQuestionsLoadingState;
